import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUser,
  faFolder,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        {/* Left Section: Navigation Links with Icons */}
        <div className="flex space-x-4">
          <Link to="/" className="hover:underline flex items-center space-x-1">
            <FontAwesomeIcon icon={faHome} />
            <span>Home</span>
          </Link>
          <Link
            to="/about"
            className="hover:underline flex items-center space-x-1"
          >
            <FontAwesomeIcon icon={faUser} />
            <span>About</span>
          </Link>
          {/* <Link to="/projects" className="hover:underline flex items-center space-x-1">
            <FontAwesomeIcon icon={faFolder} />
            <span>Projects</span>
          </Link> */}
          <Link
            to="/contact"
            className="hover:underline flex items-center space-x-1"
          >
            <FontAwesomeIcon icon={faEnvelope} />
            <span>Contact</span>
          </Link>
        </div>

        {/* Right Section: Copyright */}
        <div className="text-sm">
          &copy; {new Date().getFullYear()} Ayser World
        </div>
      </div>
    </footer>
  );
};

export default Footer;
